import React from 'react';
import { Check, ExternalLink } from 'lucide-react';
import { openCrmEntity } from 'App/shadcn/pages/Assistant/openCrmEntity';
import { useTranslation } from 'Components/Helpers/translate';

type Props = {
	contactId: number;
	/** The contact's company in the CRM; null while it loads, or when the contact has none. */
	clientName: string | null;
};

/**
 * The top of a LinkedIn profile that already is a contact (WEB-15180): a rep missed the small check
 * next to the name and could add the person again. Self-contained so the contact card can show it too.
 */
const InUpsalesBanner: React.FC<Props> = ({ contactId, clientName }) => {
	const { t } = useTranslation();
	return (
		<div className="embed-in-upsales">
			<span className="embed-in-upsales-check">
				<Check />
			</span>
			<span className="embed-add-item-info">
				<span className="embed-in-upsales-title">{t('assistant.embedAddAlreadyContact')}</span>
				{clientName ? <span className="embed-add-item-meta">{clientName}</span> : null}
			</span>
			<button type="button" className="embed-in-upsales-open" onClick={() => openCrmEntity('contact', contactId)}>
				{t('assistant.embedAddOpen')}
				<ExternalLink />
			</button>
		</div>
	);
};

export default InUpsalesBanner;
